module.exports = __webpack_public_path__ + "static/media/content-creation-c.1e893143.jpg";